<template>
  <div class="vs-main">
    <div class="vs-page-header">
      <div style="display:flex;align-items:center;gap:12px">
        <div class="vs-seg-control"><button class="vs-seg-btn active">我的消费概览</button></div>
      </div>
      <div class="vs-header-actions">
        <span class="vs-time-badge">更新时间: {{ currentDate }}</span>
      </div>
    </div>

    <!-- KPI -->
    <div class="vs-kpi-grid vs-kpi-grid-4" style="margin-bottom:20px">
      <div class="vs-kpi-card" v-for="kpi in kpiData" :key="kpi.label">
        <div class="vs-kpi-label">{{ kpi.label }}</div>
        <div class="vs-kpi-value">{{ kpi.value }}</div>
        <div class="vs-kpi-change neutral">{{ kpi.sub }}</div>
      </div>
    </div>

    <!-- 月度消费趋势 -->
    <div class="vs-card" style="margin-bottom:20px">
      <div class="vs-card-head"><span class="vs-card-label">月度消费趋势</span></div>
      <div class="vs-card-inner"><div class="vs-chart-container h280" ref="chartTrendRef"></div></div>
    </div>

    <!-- 账号TOP10 | 区域分布 -->
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:0;margin-bottom:20px">
      <div class="vs-card" style="border-right:none">
        <div class="vs-card-head"><span class="vs-card-label">账号消费 TOP 10</span></div>
        <div class="vs-card-inner"><div class="vs-chart-container h280" ref="chartTop10Ref"></div></div>
      </div>
      <div class="vs-card">
        <div class="vs-card-head"><span class="vs-card-label">区域分布</span></div>
        <div class="vs-card-inner"><div class="vs-chart-container h280" ref="chartRegionRef"></div></div>
      </div>
    </div>

    <!-- 季度同比 -->
    <div class="vs-card" style="margin-bottom:20px">
      <div class="vs-card-head"><span class="vs-card-label">季度同比</span></div>
      <div class="vs-card-inner"><div class="vs-chart-container h280" ref="chartQuarterRef"></div></div>
    </div>

    <!-- 服务明细 -->
    <div class="vs-table-wrap">
      <div class="vs-table-header"><span class="vs-table-title">服务明细</span></div>
      <div class="vs-table-toolbar" style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px">
        <div class="vs-table-filters" style="flex:1;flex-wrap:wrap;display:flex;align-items:center;gap:6px">
          <label class="vs-filter-label">时间段:</label>
          <select class="vs-form-select vs-filter-select" v-model.number="startYear" style="width:82px">
            <option v-for="y in yearOpts" :key="y" :value="y">{{ y }}年</option>
          </select>
          <select class="vs-form-select vs-filter-select" v-model.number="startMon" style="width:68px">
            <option v-for="m in monthOpts" :key="m" :value="m">{{ m }}月</option>
          </select>
          <span style="color:var(--aws-text-label);font-size:14px">至</span>
          <select class="vs-form-select vs-filter-select" v-model.number="endYear" style="width:82px">
            <option v-for="y in yearOpts" :key="y" :value="y">{{ y }}年</option>
          </select>
          <select class="vs-form-select vs-filter-select" v-model.number="endMon" style="width:68px">
            <option v-for="m in monthOpts" :key="m" :value="m">{{ m }}月</option>
          </select>
          <label class="vs-filter-label" style="margin-left:8px">账号:</label>
          <el-select v-model="filterLinkId" filterable placeholder="全部" class="vs-filter-elselect" style="width:150px" @change="loadServiceDetail">
            <el-option label="全部" value="" />
            <el-option v-for="x in linkIdOptions" :key="x" :label="x" :value="x" />
          </el-select>
          <label class="vs-filter-label">Region:</label>
          <select class="vs-form-select vs-filter-select" v-model="filterRegion" @change="loadServiceDetail" style="width:90px">
            <option value="">全部</option>
            <option value="cn">CN</option>
            <option value="global">Global</option>
          </select>
          <label class="vs-filter-label">服务:</label>
          <el-select v-model="filterServiceType" filterable placeholder="全部" class="vs-filter-elselect" style="width:160px" @change="loadServiceDetail">
            <el-option label="全部" value="" />
            <el-option v-for="x in serviceTypeOptions" :key="x" :label="x" :value="x" />
          </el-select>
        </div>
        <div style="display:flex;gap:6px;flex-shrink:0">
          <button class="vs-btn vs-btn-primary" :disabled="serviceDetailLoading" @click="loadServiceDetail()">{{ serviceDetailLoading ? '查询中…' : '查询' }}</button>
          <button class="vs-btn vs-btn-outline" :disabled="!serviceDetailData.length" @click="exportServiceDetail">CSV</button>
        </div>
      </div>
      <table class="vs-tbl">
        <thead><tr><th>账号 ID</th><th>账号名称</th><th>Payer ID</th><th>Region</th><th>服务类型</th><th class="r">金额 (USD)</th></tr></thead>
        <tbody>
          <tr v-if="!serviceDetailData.length"><td colspan="6" style="text-align:center;color:var(--aws-text-muted);padding:40px">{{ serviceDetailLoading ? '加载中…' : '请选择时间段并点击查询' }}</td></tr>
          <tr v-for="(row,idx) in pagedServiceDetail" :key="idx">
            <td>{{ row.link_id }}</td>
            <td>{{ row.customer_name || ('账号 ' + row.link_id) }}</td>
            <td>{{ row.payer_id }}</td>
            <td><span :class="['vs-tag', row.region==='cn' ? 'vs-tag-orange' : 'vs-tag-blue']">{{ row.region==='cn' ? 'CN' : 'Global' }}</span></td>
            <td>{{ row.service_type }}</td>
            <td class="r vs-text-bold">{{ fmt2(row.amount) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="vs-table-footer">
        <span class="vs-table-footer-info">显示 {{ serviceDetailData.length ? 1 : 0 }}-{{ pagedServiceDetail.length }} / 共 {{ serviceDetailData.length }} 条</span>
        <span v-if="serviceDetailData.length > 500" class="vs-table-footer-info" style="color:var(--aws-text-label)">仅显示前 500 条，请使用筛选或导出 CSV 查看全部</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue'
import * as echarts from 'echarts'
import { ElMessage } from 'element-plus'
import { ajaxGet } from '@/api/request'
import '@/assets/css/aws-console.scss'

defineOptions({ name: 'CustomerDashboard' })

const AWS_PALETTE = ['#6B9BD2','#2E5F99','#067F68','#D13212','#8C6BB1','#EC7211','#00A1C9','#879596','#DD6B7A','#3F8FD2','#1D8102','#F2C94C']
const TT = { backgroundColor: '#16191F', borderColor: '#16191F', textStyle: { color: '#fff' } }
const now = new Date()
const currentDate = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`

function fv(v) { v = Number(v) || 0; if (Math.abs(v) >= 1e5) return '$' + (v/1e6).toFixed(2) + 'M'; if (Math.abs(v) >= 1e3) return '$' + (v/1e3).toFixed(2) + 'K'; return '$' + v.toFixed(2) }
function fa(v) { return fv(v).replace('$','') }
function fmt2(v) { return Number(v||0).toFixed(2) }
function ft(params) {
  let s = params[0]?.axisValue || ''
  params.forEach(p => {
    const isPct = (p.seriesName||'').includes('增长') || (p.seriesName||'').includes('Rate')
    const f = isPct ? (p.value != null ? Number(p.value).toFixed(1) + '%' : '-') : fv(p.value)
    s += '<br/>' + p.marker + ' ' + p.seriesName + ': ' + f
  })
  return s
}
function asArr(r) { const d = r?.data ?? r; return Array.isArray(d) ? d : [] }

const kpiData = ref([
  { label: '年度总消费', value: '-', sub: '本年累计' },
  { label: '本月消费', value: '-', sub: '当月累计' },
  { label: '账号总数', value: '0', sub: '名下账号' },
  { label: '本月活跃账号', value: '0', sub: '有消费账号' },
])

const chartTrendRef = ref(null)
const chartTop10Ref = ref(null)
const chartRegionRef = ref(null)
const chartQuarterRef = ref(null)
const charts = []
function ic(el, opt) { if (!el) return; const c = echarts.getInstanceByDom(el) || echarts.init(el); c.setOption(opt, true); if (!charts.includes(c)) charts.push(c) }
function emptyOpt() { return { title: { text: '暂无数据', left: 'center', top: 'center', textStyle: { color: '#AAB7B8', fontSize: 13, fontWeight: 'normal' } } } }

async function loadData() {
  try {
    const [sum, trend, top10, region, quarter] = await Promise.all([
      ajaxGet({ url: '/stat/customer/summary/' }),
      ajaxGet({ url: '/stat/customer/monthly_trend/' }),
      ajaxGet({ url: '/stat/customer/link_top10/' }),
      ajaxGet({ url: '/stat/customer/region_dist/' }),
      ajaxGet({ url: '/stat/customer/quarterly/' }),
    ])
    const s = sum?.data ?? sum ?? {}
    kpiData.value[0].value = fv(s.year_total || 0)
    kpiData.value[1].value = fv(s.month_total || 0)
    kpiData.value[2].value = String(s.customer_count || 0)
    kpiData.value[3].value = String(s.active_customers || 0)
    renderTrend(asArr(trend))
    renderTop10(asArr(top10))
    renderRegion(asArr(region))
    renderQuarter(asArr(quarter))
  } catch (e) { console.error('CustomerDashboard loadData error:', e) }
}

function renderTrend(list) {
  if (!list.length) { ic(chartTrendRef.value, emptyOpt()); return }
  const x = list.map(i => `${i.month}月`)
  const y = list.map(i => Number(i.amount) || 0)
  ic(chartTrendRef.value, {
    grid: { left: 64, right: 24, top: 24, bottom: 30 },
    xAxis: { type: 'category', data: x, axisLine: { lineStyle: { color: '#EAEDED' } }, axisLabel: { color: '#545B64' } },
    yAxis: { type: 'value', axisLabel: { color: '#545B64', formatter: fa }, splitLine: { lineStyle: { color: '#EAEDED' } } },
    series: [{ name: '消费', type: 'line', data: y, smooth: true, symbol: 'circle', symbolSize: 7, itemStyle: { color: '#2E5F99' }, lineStyle: { width: 2, color: '#2E5F99' }, areaStyle: { color: new echarts.graphic.LinearGradient(0,0,0,1,[{offset:0,color:'rgba(46,95,153,0.18)'},{offset:1,color:'rgba(46,95,153,0.02)'}]) } }],
    tooltip: { trigger: 'axis', ...TT, formatter: ft },
  })
}

function renderTop10(list) {
  if (!list.length) { ic(chartTop10Ref.value, emptyOpt()); return }
  const names = list.map(i => { const n = i.customer_name || ('账号 ' + i.link_id); return n.length > 18 ? n.slice(0,18) + '…' : n })
  const vals = list.map(i => Number(i.amount) || 0)
  ic(chartTop10Ref.value, {
    grid: { left: 130, right: 56, top: 10, bottom: 20 },
    xAxis: { type: 'value', axisLabel: { show: false }, splitLine: { lineStyle: { color: '#EAEDED' } } },
    yAxis: { type: 'category', data: names.slice().reverse(), axisLine: { lineStyle: { color: '#EAEDED' } }, axisLabel: { color: '#545B64', fontSize: 11 } },
    series: [{ type: 'bar', data: vals.slice().reverse(), barWidth: '55%', itemStyle: { color: '#6B9BD2' }, label: { show: true, position: 'right', formatter: p => fv(p.value), color: '#545B64', fontSize: 10 } }],
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, ...TT, formatter: p => { const x = p[0]; return x.name + '<br/>' + fv(x.value) } },
  })
}

function renderRegion(list) {
  if (!list.length) { ic(chartRegionRef.value, emptyOpt()); return }
  const total = list.reduce((s,i) => s + (Number(i.amount)||0), 0) || 1
  ic(chartRegionRef.value, {
    legend: { orient: 'vertical', right: 10, top: 'center', textStyle: { color: '#545B64', fontSize: 12 } },
    series: [{ type: 'pie', radius: ['45%','70%'], center: ['38%','50%'], label: { show: false },
      data: list.map((i, idx) => ({ value: Number(i.amount) || 0, name: i.region || '?', itemStyle: { color: AWS_PALETTE[idx % AWS_PALETTE.length] } })) }],
    tooltip: { trigger: 'item', ...TT, formatter: p => p.name + '<br/>' + fv(p.value) + ' (' + (p.value/total*100).toFixed(1) + '%)' },
  })
}

function renderQuarter(list) {
  if (!list.length) { ic(chartQuarterRef.value, emptyOpt()); return }
  const qs = ['Q1','Q2','Q3','Q4']
  const years = [...new Set(list.map(i => i.year))].sort()
  const cy = years[years.length - 1]
  const ly = years.length > 1 ? years[years.length - 2] : null
  const curr = qs.map(q => { const r = list.find(d => d.year === cy && d.quarter === q); return r ? Number(r.amount) || 0 : 0 })
  const last = ly ? qs.map(q => { const r = list.find(d => d.year === ly && d.quarter === q); return r ? Number(r.amount) || 0 : 0 }) : qs.map(() => 0)
  const growth = qs.map((_, i) => (ly && last[i] > 0) ? ((curr[i] - last[i]) / last[i] * 100) : null)
  const series = []
  if (ly) series.push({ name: ly, type: 'bar', data: last, barWidth: '28%', itemStyle: { color: '#879596' } })
  series.push({ name: cy, type: 'bar', data: curr, barWidth: '28%', itemStyle: { color: '#2E5F99' } })
  if (ly) series.push({ name: '同比增长', type: 'line', yAxisIndex: 1, data: growth, connectNulls: true, lineStyle: { color: '#EC7211', width: 2 }, itemStyle: { color: '#EC7211' }, symbol: 'circle', symbolSize: 6, label: { show: true, formatter: p => p.value != null ? Number(p.value).toFixed(1) + '%' : '', color: '#EC7211', fontSize: 11 } })
  ic(chartQuarterRef.value, {
    grid: { left: 64, right: 56, top: 32, bottom: 30 },
    legend: { top: 0, textStyle: { color: '#545B64', fontSize: 12 } },
    xAxis: { type: 'category', data: qs, axisLine: { lineStyle: { color: '#EAEDED' } }, axisLabel: { color: '#545B64' } },
    yAxis: [
      { type: 'value', axisLabel: { color: '#545B64', formatter: fa }, splitLine: { lineStyle: { color: '#EAEDED' } } },
      { type: 'value', position: 'right', axisLabel: { color: '#545B64', formatter: v => v.toFixed(0) + '%' }, splitLine: { show: false } },
    ],
    series,
    tooltip: { trigger: 'axis', ...TT, formatter: ft },
  })
}

// ---- 服务明细 ----
const yearOpts = (() => { const y = now.getFullYear(); const a = []; for (let i = y; i >= 2024; i--) a.push(i); return a })()
const monthOpts = Array.from({ length: 12 }, (_, i) => i + 1)
const startYear = ref(now.getFullYear())
const startMon = ref(1)
const endYear = ref(now.getFullYear())
const endMon = ref(now.getMonth() + 1)
const startMonth = computed(() => `${startYear.value}-${String(startMon.value).padStart(2, '0')}`)
const endMonth = computed(() => `${endYear.value}-${String(endMon.value).padStart(2, '0')}`)
const filterLinkId = ref('')
const filterRegion = ref('')
const filterServiceType = ref('')
const linkIdOptions = ref([])
const serviceTypeOptions = ref([])
const serviceDetailData = ref([])
const serviceDetailLoading = ref(false)
let _sdSeq = 0
const pagedServiceDetail = computed(() => serviceDetailData.value.slice(0, 500))

async function loadServiceDetail(silent) {
  if (!startMonth.value || !endMonth.value) { if (!silent) ElMessage.warning('请选择时间段'); return }
  const seq = ++_sdSeq
  serviceDetailLoading.value = true
  try {
    const params = { start_month: startMonth.value.replace('-',''), end_month: endMonth.value.replace('-','') }
    if (filterLinkId.value) params.link_id = filterLinkId.value
    if (filterRegion.value) params.region = filterRegion.value
    if (filterServiceType.value) params.service_type = filterServiceType.value
    const res = await ajaxGet({ url: '/stat/customer/service_detail/', params })
    if (seq !== _sdSeq) return
    const list = asArr(res)
    serviceDetailData.value = list
    if (!filterLinkId.value) linkIdOptions.value = [...new Set(list.map(i => i.link_id))].filter(Boolean).sort()
    if (!filterServiceType.value) serviceTypeOptions.value = [...new Set(list.map(i => i.service_type))].filter(Boolean).sort()
    if (!silent) ElMessage.success(`查询完成，共 ${list.length} 条`)
  } catch (e) {
    if (seq === _sdSeq) { console.error('CustomerDashboard service_detail error:', e); serviceDetailData.value = []; if (!silent) ElMessage.error('查询失败') }
  } finally {
    if (seq === _sdSeq) serviceDetailLoading.value = false
  }
}

function csvEsc(v) { const s = v == null ? '' : String(v); return /[",\n]/.test(s) ? '"' + s.replace(/"/g,'""') + '"' : s }
function exportServiceDetail() {
  const rows = serviceDetailData.value
  if (!rows.length) return
  const header = ['账号ID','账号名称','Payer ID','Region','服务类型','金额(USD)']
  const body = rows.map(r => [r.link_id, r.customer_name || ('账号 ' + r.link_id), r.payer_id, r.region === 'cn' ? 'CN' : 'Global', r.service_type, fmt2(r.amount)].map(csvEsc).join(','))
  const csv = '\uFEFF' + [header.join(','), ...body].join('\n')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = `服务明细_${startMonth.value}_${endMonth.value}.csv`; a.click()
}

function handleResize() { charts.forEach(c => c.resize()) }
onMounted(() => { nextTick(async () => {
  await loadData()
  await loadServiceDetail(true)
  window.addEventListener('resize', handleResize)
}) })
onBeforeUnmount(() => { window.removeEventListener('resize', handleResize); charts.forEach(c => c.dispose()) })
</script>

<style lang="scss" scoped>
.vs-main { margin: -24px; padding: 20px 28px 40px; }
.vs-filter-label { font-size: 14px; color: var(--aws-text-secondary); font-weight: 400; white-space: nowrap; }
.vs-filter-select { color: var(--aws-text-primary); }
.vs-filter-elselect {
  :deep(.el-input__wrapper) { border-radius: 2px; min-height: 34px; box-shadow: 0 0 0 1px var(--aws-border) inset; }
  :deep(.el-input__wrapper.is-focus) { box-shadow: 0 0 0 1px var(--aws-link) inset; }
  :deep(.el-input__inner) { font-size: 14px; font-family: var(--aws-font); color: var(--aws-text-primary); }
  :deep(.el-input__inner::placeholder) { color: var(--aws-text-muted); }
}
</style>
